export const icons = [
  'chevron-right',
  'icon-kinderopvang',
  'icon-voetbal',
  'icon-gallery-grid',
  'chevron-left',
  'house-icon',
  'arrow-top-right',
  'search',
  'icon-buurtwerk',
  'header-gradient',
  'kinderopvang-decorative',
  'maternity-care-decorative',
  'youth-support-decorative',
  'icon-thumbsup',
  'icon-checkmark',
  'icon-external-link'
] as const

export type Icon = (typeof icons)[number]

// Note: type guard
export function isIcon(icon: string): icon is Icon {
  return icons.includes(icon as Icon)
}

